export function getEnv() {
  return import.meta.env.VITE_APP_ENV;
}

export function getBaseUrl() {
  return import.meta.env.VITE_APP_API_BASE_URL as string;
}
